import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { PhotosTab } from "./photos-tab";

export const VectorTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => {
  const { t } = useTranslation();

  return (
    <PhotosTab endpoint="/photos/vector" placeholder={t("Search curated images")} {...props} />
  );
};
